import React from "react";
import PropTypes from "prop-types";
import { Button } from "@learningblocks/shared-components";

import style from "./style.module.scss";

export function HintButton(props) {
  const className = `${style.hintButton} ${props.className}`;
  return (
    <Button
      className={className}
      tabIndex={props.tabIndex}
      onClick={props.onClick}
      children={props.children}
    />
  );
}

HintButton.propTypes = {
  /**
   * classname for custom style of component
   */
  className: PropTypes.string,
  /**
   * for keyboard accessibility
   */
  tabIndex: PropTypes.number,
  /**
   * callback for hint button on click
   */
  onClick: PropTypes.func.isRequired,
};

HintButton.defaultProps = {
  className: "",
};
